module.exports = "/static/media/email-icon-white.84bb2edb.png";